/**
 * Can this blob's bytes actually be read? False for "dangling" blobs — lazy
 * file-backed handles (IndexedDB blob storage / OPFS) whose backing was
 * deleted or rewritten after the handle was obtained. A 1-byte slice read is
 * enough to prove liveness.
 *
 * Serve paths use this to degrade a dead handle into a cache miss (re-fetch)
 * instead of a broken image / dead-URL video; the IndexedDB fallback in
 * attachmentStorage uses it to avoid persisting poisoned content.
 *
 * Dependency-free ON PURPOSE: it is imported from the middleware layer, and
 * routing it through attachmentStorage pulled environmentDetector (and its
 * window API needs) into module graphs that never touch storage.
 */
export async function isBlobReadable(blob: Blob): Promise<boolean> {
  try {
    await blob.slice(0, 1).arrayBuffer();
    return true;
  } catch {
    return false;
  }
}
